import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../services/api";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
  },
  paper: {
    padding: theme.spacing(4),
    width: 400,
    borderRadius: 16,
    textAlign: "center",
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  button: {
    backgroundColor: "#16a34a",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#15803d",
    },
  },
  link: {
    marginTop: theme.spacing(2),
    color: "#2563eb",
    cursor: "pointer",
  },
}));

export default function Register({ history }) {
  const classes = useStyles();
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = async () => {
    if (!nome || !email || !senha) {
      toast.warning("Preencha todos os campos");
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { nome, email, senha });

      if (data.success) {
        localStorage.setItem("token", data.token);
        toast.success("Cadastro realizado com sucesso!");
        window.location.href = "/pedidos"; // redireciona pro sistema
      } else {
        toast.error(data.message || "Erro ao cadastrar");
      }
    } catch (err) {
      console.error("❌ Erro ao registrar:", err);
      toast.error(err.response?.data?.message || "Erro ao registrar usuário");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <Typography variant="h5" gutterBottom>
          🧾 Criar Conta
        </Typography>

        <TextField
          label="Nome"
          fullWidth
          variant="outlined"
          className={classes.field}
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />

        <TextField
          label="E-mail"
          type="email"
          fullWidth
          variant="outlined"
          className={classes.field}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <TextField
          label="Senha"
          type="password"
          fullWidth
          variant="outlined"
          className={classes.field}
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />

        <Button
          fullWidth
          variant="contained"
          className={classes.button}
          onClick={handleRegister}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Cadastrar"}
        </Button>

        <Typography
          className={classes.link}
          onClick={() => (window.location.href = "/login")}
        >
          Já tem uma conta? Faça login
        </Typography>
      </Paper>
    </Box>
  );
}
